import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch a farm organization's climate data
 * @param {Object} params
 * @param {string} params.orgId - (Farm) Orgnization ID to fetch climate climateData for
 * @returns {Object} Schedule climateData, phases, loading state, and error
 */
export const useClimate = ({ farmId }) => {
  const [climateData, setClimateData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      if (!farmId) {
        setClimateData(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Fetch active climate
        const { data, error: climateError } =
          await supabaseGetter.climates.getByOrganization(farmId);

        if (climateError) throw climateError;

        setClimateData(data || null);
      } catch (err) {
        console.error('Error fetching crop climate climateData:', err);
        setError(err.message);
        setClimateData(null);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [farmId]);

  return {
    climateData,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropSchedules.invalidate();
      supabaseGetter.cropPhases.invalidate();
    }
  };
}
